import RecaptchaWrapper from "./recaptcha-wrapper";
import ReCAPTCHA from "./recaptcha";

export default RecaptchaWrapper;
export { ReCAPTCHA };